import { useState, useCallback } from 'react';
import { disableUser } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useDisableUser({ onSuccess } = {}) {
  const [loadingId, setLoadingId] = useState(null);
  const [error, setError] = useState(null);

  const clearError = useCallback(() => setError(null), []);

  const disable = useCallback(async (userId) => {
    setError(null);
    setLoadingId(userId);
    try {
      await disableUser(userId);
      if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
      const msg = handleApiError(err);
      setError(msg);
    } finally {
      setLoadingId(null);
    }
  }, [onSuccess]);

  return { disable, loadingId, error, clearError };
}


